import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { useDispatch } from 'react-redux';
import { postRefreshToken } from 'src/redux/slices/auth';
// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const authState = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(postRefreshToken({refreshToken: authState.refreshToken }))
  }, [children])

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (authState.accessToken.length === 0) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
